import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmDialogOptions } from '@fleet-beat/core';
import { Observable } from 'rxjs';
import { confirmDialogDefaultOptions } from '../configs/confirm-dialog-default.configs';
import { ConfirmDialogContainerComponent } from '../containers/confirm-dialog/confirm-dialog-container.component';

@Injectable({
  providedIn: 'root',
})
export class ConfirmDialogService {
  constructor(private dialog: MatDialog) {}

  confirm<T>(options: Partial<ConfirmDialogOptions<T>>, width: string = '560px'): Observable<T | boolean> {
    const dialogOption: MatDialogConfig<ConfirmDialogOptions<T | boolean>> = {
      width,
      disableClose: true,
      panelClass:
        options.currentThemeMode === 'dark' ? ['dark-theme', 'confirm-dialog'] : ['light-theme', 'confirm-dialog'],
      autoFocus: false,
      data: { ...confirmDialogDefaultOptions, ...options },
    };

    return this.dialog.open(ConfirmDialogContainerComponent, dialogOption).beforeClosed();
  }
}
